function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#003b81",
  fillRule: "evenodd",
  d: "M14.009 12.4l6.57-6.571a1.42 1.42 0 10-2.008-2.012L12 10.387l-6.571-6.57a1.422 1.422 0 10-2.012 2.012l6.57 6.571-6.57 6.571a1.422 1.422 0 102.012 2.012L12 14.413l6.571 6.57a1.422 1.422 0 102.012-2.012L14.01 12.4z"
});

var SvgCloseCalc = function SvgCloseCalc(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 25
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI0IDI1Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDNiODEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjAwOSAxMi40bDYuNTctNi41NzFjLjU1Ni0uNTU1LjU1Ny0xLjQ1NS4wMDItMi4wMS0uNTU0LS41NTYtMS40NTQtLjU1Ny0yLjAxLS4wMDJMMTIgMTAuMzg3bC02LjU3MS02LjU3Yy0uNTU2LS41NTYtMS40NTctLjU1Ni0yLjAxMiAwLS41NTYuNTU1LS41NTYgMS40NTYgMCAyLjAxMmw2LjU3IDYuNTcxLTYuNTcgNi41NzFjLS41NTYuNTU2LS41NTYgMS40NTcgMCAyLjAxMi41NTUuNTU2IDEuNDU2LjU1NiAyLjAxMiAwTDEyIDE0LjQxM2w2LjU3MSA2LjU3Yy41NTYuNTU2IDEuNDU3LjU1NiAyLjAxMiAwIC41NTYtLjU1NS41NTYtMS40NTYgMC0yLjAxMkwxNC4wMSAxMi40eiIvPgo8L3N2Zz4K";
export { SvgCloseCalc as ReactComponent };